import { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { cards } from "../helper/terminalData";

const SellingOne = ({ handleOpenModal }) => {
  const { t, i18n } = useTranslation();

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button className={className} onClick={onClick}>
        <i className="las la-arrow-left" />
      </button>
    );
  }
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const pdfUrl = `/assets/pdfs/equipment-${i18n.language}.pdf`;

  return (
    <section className="selling-product padding-y-120 position-relative z-index-1 overflow-hidden">
      <img
        src="/assets/images/gradients/selling-gradient.png"
        alt=""
        className="bg--gradient"
      />
      <img
        src="/assets/images/shapes/curve-pattern1.png"
        alt=""
        className="position-absolute start-0 top-0 z-index--1"
      />
      <img
        src="/assets/images/shapes/curve-pattern2.png"
        alt=""
        className="position-absolute end-0 top-0 z-index--1"
      />
      <div className="container container-two">
        <div className="section-heading style-left style-white flx-between max-w-unset gap-4">
          <div>
            <h3 className="section-heading__title">
              {t("terminal_catalog.title")}
            </h3>
            <p className="section-heading__desc font-18">
              {t("terminal_catalog.description")}
            </p>
          </div>

          {/* <a
            href={pdfUrl}
            download
            className="btn btn-outline-static-white pill"
            id="equipment-download-button"
          >
            <span className="icon-left icon">
              <img src="/assets/images/icons/download-01.svg" alt="download" />
            </span>
            {t("terminal_catalog.download_all_info")}
          </a> */}
        </div>
        <div className="selling-product-slider">
          {/* <Slider {...settings}> */}
          <div className="selling-product__cards">
            {cards.map((item) => {
              const baseKey = `terminal_catalog.terminal_cards.${item.key}`;
              return (
                <div
                  key={item.id}
                  className="product-item shadow-sm overlay-none"
                >
                  <div className="product-item__thumb d-flex max-h-unset">
                    <div className="link w-100">
                      <img
                        src={item.images[0]}
                        alt={t(`${baseKey}.name`)}
                        className="cover-img"
                      />
                    </div>
                  </div>

                  <div className="product-item__content">
                    <h6 className="product-item__title">
                      <div className="link">
                        {t(`${baseKey}.name`)}
                      </div>
                    </h6>

                    {/* <div className="product-item__info flx-between gap-2"> */}
                    <h4 className="product-item__author">
                      {t(`${baseKey}.short`)}
                    </h4>
                   {/*  <div
                      style={{ marginTop: "4px" }}
                      className="flx-align gap-2"
                    >
                      <h6 className="product-item__price mb-0">
                        {t(`${baseKey}.price_short`)}
                      </h6>
                    </div> */}
                    {/* </div> */}

                    <div className="product-item__bottom flx-end gap-2">
                      <div className="flx-align gap-2">
                        {/* change Link → button so it doesn't navigate */}
                        <button
                          type="button"
                          className="btn btn-outline-light pill"
                          onClick={() => handleOpenModal(item.id)}
                        >
                          {t("terminal_catalog.more_info")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* </Slider> */}
        </div>
      </div>
    </section>
  );
};

export default SellingOne;

